import {useState} from "react";
import styles from "./OrganizerEventPage.module.scss";
import {OrganizerEventPage} from "./EditEvent/OrganizerEventPage";
import {TicketVerification} from "./TicketVerification/TicketVerification";

type tabType = "edit" | "info_tickets" | "check_tickets"

export const OrganizerEventPageSecond = () => {
    const [tab, setTab] = useState<tabType>("check_tickets");

    const handleTab = (newTab : tabType) => {
        console.log("клик")
        if(newTab === tab) return;

        setTab(newTab);
    }

    return (
        <div className={styles.orgEventPage}>
            {//---------------------------------Выбор вкладки------------------------------------------------------
            <div className={styles.switchWrapper}>
                <button className={`${styles.button} ${tab === "edit" ? styles['button--active'] : ''}`}
                        onClick={() => handleTab("edit")}>Редактировать событие</button>
                <button className={`${styles.button} ${tab === "info_tickets" ? styles['button--active'] : ''}`}
                        onClick={() => handleTab("info_tickets")}>Информация о билетах</button>
                <button className={`${styles.button} ${tab === "check_tickets" ? styles['button--active'] : ''}`}
                        onClick={() => handleTab("check_tickets")}>Проверка билетов</button>
            </div>}
            { tab === "edit" && <OrganizerEventPage/> }
            { tab === "info_tickets" && <div>Информация о билетах</div> }
            { tab === "check_tickets" && <TicketVerification />}
        </div>
    )
}